import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { Button, notification, Typography } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import { ISalesItem, TSalesDraftItem } from 'store/slices/sales/interfaces';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  deleteSalesItem,
  loadSalesItem,
  saveSalesItem,
  saveSalesItemAsDraft,
} from 'store/slices/sales/actions';
import { StatusesEnum } from 'constants/status';
import { StickyConfirmModal } from 'components/modals/StickyConfirmModal';

import { SalesForm } from './components/SalesForm/SalesForm';
import { mapValuesToForm } from './components/SalesForm/formUtils';

export const Edit = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.sales);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    dispatch(loadSalesItem(id));
  }, []);

  const onFinish = (values: ISalesItem) => {
    setIsLoading(true);
    dispatch(saveSalesItem({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/sales');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: TSalesDraftItem) => {
    setIsLoading(true);
    dispatch(saveSalesItemAsDraft({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/sales');
      })
      .catch(() => setIsLoading(false));
  };

  const handleDelete = async id => {
    setIsLoading(true);
    await dispatch(deleteSalesItem(id))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно удалена',
        });
        navigate('/sales');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/sales');
  };

  return (
    <MainLayout
      pageTitle='Редактирование'
      extraButtonsList={[
        <Button
          key='delete'
          danger
          onClick={() => String(item.id) == id && setIsModalOpen(true)}
        >
          Удалить
        </Button>,
      ]}
    >
      {item.id && String(item.id) == id ? (
        <>
          <SalesForm
            onFinish={onFinish}
            onSaveDraft={onSaveDraft}
            cancelButtonHandler={cancelButtonHandler}
            isDraft={item.status === StatusesEnum.DRAFT}
            isLoading={isLoading}
            initialValues={mapValuesToForm(item)}
          />
          {isModalOpen && (
            <StickyConfirmModal
              isOpen={isModalOpen}
              onRequestClose={() => setIsModalOpen(false)}
              title='Удаление сущности продажи'
              okText='Удалить'
              text={
                <div>
                  Вы хотите убрать с портала и переместить в Корзину{' '}
                  <Typography.Text strong>{item.name || ''}</Typography.Text>?
                </div>
              }
              onSubmit={() => handleDelete(item.id)}
              okButtonProps={{ danger: true }}
            />
          )}
        </>
      ) : null}
    </MainLayout>
  );
};
